var map = {
	"./api-integrations.jpg": "14b2",
	"./api-integrations2.jpg": "736b",
	"./fico-world.jpg": "3827",
	"./flagship.jpg": "4064",
	"./mobile-app-redesign.jpg": "88a3",
	"./premier-agenda-builder.jpg": "04f1",
	"./rolr-redesign.jpg": "0b56",
	"./tableseating.jpg": "54b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cc1f";